export const convertDurationToMinutes = (
    duration: number | undefined
): string => {
    if (duration && String(duration).split('').length > 3) {
        return `${Math.floor(duration / 1000 / 60)} min`
    } else if (duration) return String(duration)

    return '0'
}
